import { render, staticRenderFns } from "./FactorValueEdit.vue?vue&type=template&id=c2a38052&scoped=true"
import script from "./FactorValueEdit.vue?vue&type=script&lang=js"
export * from "./FactorValueEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a38052",
  null
  
)

export default component.exports